import {useAppSelector} from "../../../store/hooks/use_app_selector";
import {selectUserProfile} from "../api/user_api";

export const useUserProfileData = () => {
    const userProfile = useAppSelector(selectUserProfile);

    return {
        userProfile,
        userData: userProfile.data ?? null
    };
};
import {useAppSelector} from "../../../store/hooks/use_app_selector";
import {selectUserProfile} from "../api/user_api";

export const useUserProfileData = () => {
    const userProfile = useAppSelector(selectUserProfile);

    return {
        userProfile,
        userData: userProfile.data ?? null
    };
};
